<template>
  <v-layout row justify-center>
    <v-dialog v-model="showFinancialPlan" max-width="630px"
      transition="dialog-bottom-transition" @keydown.esc="showFinancialPlan = false">
      <v-card>
        <v-toolbar color="blue-grey lighten-5">
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-xs-center">SELECIONAR PLANO</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="showFinancialPlan = false">
            <v-icon>fal fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-select :items="plans" item-text="description" item-value="id" v-model="selectedPlan"
                  append-icon="fal fa-chevron-down" label="Plano" single-line required></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.stop="addUserOnPlan()" round large depressed color="success"
            :loading="loadingRequest">
            Salvar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'

export default {
  props: ['userMP'],

  data: () => ({
    showFinancialPlan: false,
    loadingRequest: false,
    user: {},
    selectedPlan: '',
    plans: []
  }),

  methods: {
    loadPlans () {
      for (let plan of Object.keys(API.plans)) {
        const planID = API.plans[plan]
        const path = `${API.mpPlans}/${planID}`
        axios.get(path).then(response => {
          if (response && response.data && response.data.plan.response) {
            this.plans = this.plans.concat(response.data.plan.response)
          }
        })
      }
    },

    setSelectedPlanName (object, value) {
      return Object.keys(API.plans).find(key => object[key] === value)
    },

    updateUserOnMp (user) {
      const path = `${API.mpCustomers}/${user.id}`

      const params = {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        identification: { number: this.user.document_number },
        metadata: {
          subscription_id: user.metadata.subscription_id,
          plan_id: user.metadata.plan_id,
          app_user_id: this.user._id
        }
      }

      axios.put(path, params).catch(errors => {
        this.loadingRequest = false
        // EventBus.$emit('showSnackbar', { message: errors.response.data.message, color: 'error' })
        EventBus.$emit('showSnackbar', { message: 'Erro atualizar usuário no Mercado Pago', color: 'error' })
      })
    },

    addUserOnPlan () {
      this.loadingRequest = true
      const path = `${API.mpSubscriptions}`
      const params = {
        plan_id: this.selectedPlan,
        payer: {
          id: this.userMP.id
        }
      }

      axios.post(path, params).then(response => {
        this.loadingRequest = false
        let user = this.userMP
        user.metadata = {
          subscription_id: response.data.preapproval.response.id,
          plan_id: this.selectedPlan
        }

        this.showFinancialPlan = false
        this.updateUserOnMp(user)
        this.updateUserPlan()
        EventBus.$emit('loadPlan')
        EventBus.$emit('showSnackbar', { message: 'Plano adicionado ao aluno com sucesso!', color: 'success' })
      }).catch(errors => {
        this.loadingRequest = false
        // EventBus.$emit('showSnackbar', { message: errors.response.data.message, color: 'error' })
        EventBus.$emit('showSnackbar', { message: 'Erro adicionar usuário ao plano no Mercado Pago', color: 'error' })
      })
    },

    updateUserPlan () {
      const params = {
        plan: this.setSelectedPlanName(API.plans, this.selectedPlan)
      }
      axios.put(`${API.users}/${this.user._id}`, params)
    }
  },

  beforeDestroy () {
    EventBus.$off('showFinancialPlan')
    EventBus.$off('showFinancialPlanData')
    EventBus.$off('loadUserOnMP')
  },

  mounted () {
    EventBus.$on('showFinancialPlan', data => {
      this.showFinancialPlan = data
    })

    EventBus.$on('showFinancialPlanData', data => {
      this.user = data
    })

    this.loadPlans()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/userShow/AdminUserShowFinancialPlan.vue